import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import styles from "components/documents/payment-type-filter-field.scss";
import { cardNumberType } from "custom-prop-types";

export const PaymentTypeFilterField = ({
  cardNumbers,
  lastFourDigits,
  onAddPaymentType,
  onAddCardNumber,
  selectedPaymentTypes
}) => {
  if (selectedPaymentTypes.indexOf("credit-card") > -1) {
    return (
      <div>
        <div className={ styles["payment-title"] }>Payment Type</div>
        <div className={ styles["digits-title"] }>Last four digits</div>
        <div className={ styles["payment-type-container"] }>
          <Select
            className={ styles["shared-select"] }
            onChange={ onAddPaymentType }
            options={ mapPaymentTypes(paymentTypes) }
            placeholder="Add a payment type"
          />
          <Select
            className={ `${styles["shared-select"]} ${styles.lastFourDigits}` }
            defaultValue={ lastFourDigits || "" }
            onChange={ (e) => { onAddCardNumber(e); } }
            options={ mapCardNumbers(cardNumbers) }
            placeholder="Last four digits..."
          />
        </div>
      </div>
    );
  }
  return (
    <div>
      <div>Payment Type</div>
      <Select
        onChange={ onAddPaymentType }
        options={ mapPaymentTypes(paymentTypes) }
        placeholder="Add a payment type"
      />
    </div>
  );
};

PaymentTypeFilterField.defaultProps = {
  lastFourDigits: null
};

PaymentTypeFilterField.propTypes = {
  cardNumbers: PropTypes.arrayOf(cardNumberType).isRequired,
  lastFourDigits: PropTypes.string,
  onAddCardNumber: PropTypes.func.isRequired,
  onAddPaymentType: PropTypes.func.isRequired,
  selectedPaymentTypes: PropTypes.arrayOf(PropTypes.string).isRequired
};

const paymentTypes = [
  { key: "credit-card", name: "Card" },
  { key: "cash", name: "Cash" },
  { key: "check", name: "Cheque" },
  { key: "paypal", name: "PayPal" },
  { key: "other", name: "Other" }
];
const mapPaymentTypes = (payments) => payments.map(payment => ({ label: payment.name, key: payment.key }));
const mapCardNumbers = (cardNumbers) => (
  cardNumbers.filter(card => card.lastFourDigits !== null)
    .map(card => ({ label: card.name, key: card.lastFourDigits }))
);



// WEBPACK FOOTER //
// ./src/js/components/documents/filters/payment-type-filter-field.jsx